/** Build-time branding（UAT：FlyTaxi；PROD：搭的） */
export const crmBrandTitle =
  import.meta.env.VITE_CRM_BRAND_TITLE?.trim() || '搭的後台';

export const crmBrandName = import.meta.env.VITE_CRM_BRAND_NAME?.trim() || '搭的';

export const crmEnvLabel = import.meta.env.VITE_CRM_ENV_LABEL?.trim() || 'UAT';

export const crmPublicHost =
  import.meta.env.VITE_CRM_PUBLIC_HOST?.trim() || 'flytaxi.hkcodai.space';
